<template>
    <modal
        :saveAction="saveAction"
        :title="$t(title)"
        :deleteAction="data._id ? data.can_delete ? deleteAction : false : false"
        :id="id"
        :actionButtons="false"
        size="md"
        :closeButton="true"
        @shown="shown"
    >
        <template slot="modal-header">
            <div></div>
        </template>

        <div class="receipt">
            <div class="row d-flex justify-content-center mt-3 mb-4">
                <div class="col-2">
                    <img src="@/assets/img/illustrations/success.svg" alt />
                </div>
                <div class="col-12">
                    <h1
                        class="mt-3"
                        style="text-align: center; color: green; font-size: 30px; font-weight: 300;"
                    >{{$t('Payment successful')}}</h1>
                </div>
            </div>

            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <p>{{$t('Patient')}}</p>
                </div>
                <div class="col-auto">
                    <p>{{ data.customer.first_name}} {{data.customer.last_name }}</p>
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <p>{{$t('Date')}}</p>
                </div>
                <div class="col-auto">
                    <p>{{ data.invoice.createdAt | moment("H:MM, DD/MM/YYYY") }}</p>
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <p>{{$t('Treatments')}}</p>
                </div>
                <div class="col-auto">
                    <div v-for="(service, key) in data.invoice.services" :key="key">
                        <span v-if="service.product">{{service.product.label}}</span>
                        <span v-else>{{ service.treatment.label }}</span>
                    </div>
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <p>{{$t('Payment method')}}</p>
                </div>
                <div class="col-auto">
                    <div v-for="(payment, key) in data.invoice.payments" :key="key">
                        <span>
                            {{ $t(payment.paymentMethod) }} -
                            <small>
                                <money :value="payment.toPay" />
                            </small>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <p>{{$t('Total Payment')}}</p>
                </div>
                <div class="col-auto">
                    <money :value="data.invoice.totalPrice" />
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <h2>{{$t('Paid amount')}}</h2>
                </div>
                <div class="col-auto">
                    <h2>
                        <money :value="data.invoice.totalPaid" />
                    </h2>
                </div>
            </div>
            <div class="row d-flex justify-content-between">
                <div class="col-auto">
                    <p>{{$t('Transaction ID')}}</p>
                </div>
                <div class="col-auto">
                    <p>{{ '#' + data.invoice.invoiceNumber }}</p>
                </div>
            </div>
        </div>

        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button
                            type="button"
                            @click="invoiceModal(data.invoice._id, true)"
                            class="btn btn-secondary m-2"
                        >{{$t('Print')}}</button>
                        <button type="button" @click="close" class="btn btn-white">{{$t('Close')}}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money";
import { modalMixins } from '@/mixins/modal.js'

export default {
    name: 'PaymentResultForm',
    props: ['id'],
    mixins: [modalMixins],
    components: {
        Modal,
        Money
    },
    data() {
        return {
            labels: ['Patient name', 'Treatment', 'Date', 'Payment Method', 'Transaction ID'],
            hideForm: false,
            title: 'Payment status',
            errors: {},
            data: {
                invoice: [],
                customer: [],
            }
        }
    },
    computed: {},
    methods: {
        shown() {
            this.errors = {};
            this.data = {};
            const { Invoice } = this.$FeathersVuex;
            let data = Invoice.getFromStore('temp');
            //console.log(data);
            if (data) {
                delete data._id;
                this.data.customer = JSON.parse(JSON.stringify(data['customer']));
                this.data.invoice = JSON.parse(JSON.stringify(data['invoice']));
                new Invoice({
                    model: {},
                    _id: 'temp'
                });
            }
            // this.data.label.focus();
        },
        close() {
            this.$root.$emit('bv::hide::modal', this.id);
            //Object.assign(this.data, this.beforeEditingCache);
        },

        saveAction() {

        }
    }
}
</script>

<style lang="scss">
.receipt {
    padding: 0 15px 0 15px;
    p {
        font-size: 16px;
        line-height: 15px;
    }

    h2 {
        padding: 10px 0;
    }
}

</style>
